import React from 'react';
export const CFIconArrowCornerDownRight = {
    alias: 'arrow-corner-down-right',
    defaultTitle: 'Arrow Corner Down Right',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm19.781 12.376-4-5a.999.999 0 1 0-1.562 1.249l2.701 3.376H8c-.551 0-1-.449-1-1v-5a1 1 0 1 0-2 0v5c0 1.654 1.346 3 3 3h8.92l-2.701 3.375A.999.999 0 0 0 15 19.001a.997.997 0 0 0 .781-.376l4-5a1 1 0 0 0 0-1.249Z' }))),
};
